import {
  IconElement,
  MessageModalLayoutProps,
  TooltipCommonProps,
} from '@wix/design-system';

interface TableActionCellSecondaryAction {
  text: string;
  icon?: IconElement | false;
  onClick: () => void;
  disabled?: boolean;
  disabledDescription?: string;
  tooltipProps?: TooltipCommonProps;
  dataHook?: string;
}

export interface DeleteModalProps extends MessageModalLayoutProps {
  /**
   * A [TableActionCellSecondaryAction](https://www.docs.wixdesignsystem.com/?activeTab=API&path=%2Fstory%2Fcomponents-api-components--tableactioncell) object to customize the "Delete" secondary action.<br>
   */
  actionProps?: Partial<TableActionCellSecondaryAction>;
}
